import * as React from "react";
function SvgIcFontSize(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.736 5H20v1h-4.267l.003 13h-1.067l-.002-13H10.4V5h5.336zm-7.47 14v-9h3.2V9H4v1h3.199v9h1.067z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcFontSize;
